import React from "react";

const SvgMouthUp = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="MouthUp_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#MouthUp_svg__a)">
      <mask id="MouthUp_svg__b" x="-200%" y="-200%" width="400%" height="400%">
        <rect x="-200%" y="-200%" width="400%" height="400%" fill="#fff" />
        <path d="M133.86 70.43s52.33 8.08 58.66 13.29l6.33 5.21s-.37 1.12-10 0l-57.79.5 2.8-19z" />
      </mask>
      <path
        d="M133.86 70.43s52.33 8.08 58.66 13.29l6.33 5.21s-.37 1.12-10 0l-57.79.5 2.8-19z"
        fill="#FFF"
        mask="url(#MouthUp_svg__b)"
        strokeWidth={4}
        stroke="#1D1D1B"
        strokeMiterlimit={10}
      />
    </g>
  </svg>
);

export default SvgMouthUp;